import { render } from "./DashboardProcurement.vue?vue&type=template&id=79e1330a&scoped=true"
import script from "./DashboardProcurement.vue?vue&type=script&lang=js"
export * from "./DashboardProcurement.vue?vue&type=script&lang=js"

import "./DashboardProcurement.vue?vue&type=style&index=0&id=79e1330a&scoped=true&lang=css"
import "./DashboardProcurement.vue?vue&type=style&index=1&id=79e1330a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e1330a"]])

export default __exports__